import { render, staticRenderFns } from "./upImg.vue?vue&type=template&id=71ba6934&scoped=true"
import script from "./upImg.vue?vue&type=script&lang=js"
export * from "./upImg.vue?vue&type=script&lang=js"
import style0 from "./upImg.vue?vue&type=style&index=0&id=71ba6934&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba6934",
  null
  
)

export default component.exports